var map = {
	"./img02.jpeg": "50d8",
	"./img03.jpeg": "fb9c",
	"./img04.jpeg": "1710",
	"./img05.jpeg": "8500",
	"./img06.jpeg": "79db",
	"./img07.jpeg": "f830",
	"./img08.jpeg": "f353",
	"./img09.png": "0120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73d4";